module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_a_blanco-5948c3f7b01550f22527a5a4852fac7c.svg";